module.exports = __webpack_public_path__ + "img/weixinpay.bc4c688b.png";